import React, { Component } from 'react';
import i18n from 'utils/translate';
import sortBy from 'lodash/sortBy';
import {
  FILTER_LANGUAGE,
  FILTER_REGION_COMMUNITY,
  FILTER_REGION_NAME,
  FILTER_REGISTERS_LONGNAME,
  FILTER_ZIP,
  FILTER_ZIP_AND_COMMUNITY,
  getRegionByCommunity,
  getRegionByZipcode,
  FILTER_LASTNAME
} from '../../utils/filters';
import FilterField from '../../components-shared/FilterField';

const defaultProps = {
  renderedFields: [],
  filters: [],
  onFiltersChanged: () => {},
  regions: [],
  zipcodeOptions: [],
  zipcodeAndCommunityOptions: [],
  communityOptions: [],
  regionOptions: [],
  languageOptions: [],
  registersLongnameOptions: [],
  zipAndCommunityOptions: [],
  lastnameOptions: []
};

class SidebarFilter extends Component {
  handleZipChange(change) {
    const changes = [];
    changes.push({ change: change, filter: FILTER_ZIP });
    if (change) {
      const region = getRegionByZipcode(change.value, this.props.regions);
      if (region) {
        changes.push({ change: { value: region.name }, filter: FILTER_REGION_NAME });
        changes.push({ change: { value: region.community }, filter: FILTER_REGION_COMMUNITY });
      }
    }
    this.handleChanges(changes);
  }

  handleCommunityChange(change) {
    const changes = [];
    changes.push({ change: change, filter: FILTER_REGION_COMMUNITY });
    changes.push({ change: null, filter: FILTER_ZIP });
    if (change) {
      const region = getRegionByCommunity(change.value, this.props.regions);
      if (region) {
        changes.push({ change: { value: region.name }, filter: FILTER_REGION_NAME });
      }
    }
    this.handleChanges(changes);
  }

  handleRegionChange(change) {
    this.handleChanges([
      { change: change, filter: FILTER_REGION_NAME },
      { change: null, filter: FILTER_REGION_COMMUNITY },
      { change: null, filter: FILTER_ZIP }
    ]);
  }

  handleLanguageChange(change) {
    this.handleChanges([{ change: change, filter: FILTER_LANGUAGE }]);
  }

  handleRegistersLongnameChange(change) {
    this.handleChanges([{ change: change, filter: FILTER_REGISTERS_LONGNAME }], true);
  }

  handleZipAndCommunityChange(change) {
    this.handleChanges([{ change: change, filter: FILTER_ZIP_AND_COMMUNITY }], true);
  }

  handleLastnameChange(change) {
    this.handleChanges([{ change: change, filter: FILTER_LASTNAME }], true);
  }

  handleChanges(changes, areChangesExclusive) {
    let filters = { ...this.props.filters };
    if (areChangesExclusive) {
      filters = {};
    }

    for (const change of changes) {
      const path = change.filter;
      if (change.change) {
        filters[path] = change.change.value;
      } else {
        delete filters[path];
      }
    }

    this.props.onFiltersChanged(filters);
  }

  render() {
    const { renderedFields } = this.props;
    const filtersContent = renderedFields.map(filter => {
      switch (filter) {
        case FILTER_ZIP_AND_COMMUNITY:
          return this.renderZipAndCommunityFilter();
        case FILTER_ZIP:
          return this.renderZipFilter();
        case FILTER_REGION_COMMUNITY:
          return this.renderCommunityFilter();
        case FILTER_REGION_NAME:
          return this.renderRegionFilter();
        case FILTER_LANGUAGE:
          return this.renderLanguageFilter();
        case FILTER_REGISTERS_LONGNAME:
          return this.renderRegistersLongnameFilter();
        case FILTER_LASTNAME:
          return this.renderLastnameFilter();
        default:
          return <></>;
      }
    });
    return (
      <div>
        <div className="sidebar-header">{i18n('filter-title')}</div>
        {filtersContent}
      </div>
    );
  }

  renderZipFilter() {
    const { zipcodeOptions, filters } = this.props;
    return (
      <div className="sidebar-section" key={FILTER_ZIP}>
        <FilterField
          label={i18n('zip-label')}
          options={zipcodeOptions}
          onChange={change => this.handleZipChange(change)}
          defaultValue={filters[FILTER_ZIP] ? filters[FILTER_ZIP] : null}
          isDisabled={this.isFilterFieldDisabled(FILTER_ZIP)}
        ></FilterField>
      </div>
    );
  }

  renderCommunityFilter() {
    const { communityOptions, filters } = this.props;
    return (
      <div className="sidebar-section" key={FILTER_REGION_COMMUNITY}>
        <FilterField
          label={i18n('community-label')}
          options={communityOptions}
          onChange={change => this.handleCommunityChange(change)}
          defaultValue={filters[FILTER_REGION_COMMUNITY] ? filters[FILTER_REGION_COMMUNITY] : null}
          isDisabled={this.isFilterFieldDisabled(FILTER_REGION_COMMUNITY)}
        ></FilterField>
      </div>
    );
  }

  renderRegionFilter() {
    const { regionOptions, filters } = this.props;
    return (
      <div className="sidebar-section" key={FILTER_REGION_NAME}>
        <FilterField
          label={i18n('region-label')}
          options={regionOptions}
          onChange={change => this.handleRegionChange(change)}
          defaultValue={filters[FILTER_REGION_NAME] ? filters[FILTER_REGION_NAME] : null}
          isDisabled={this.isFilterFieldDisabled(FILTER_REGION_NAME)}
        ></FilterField>
      </div>
    );
  }

  renderLanguageFilter() {
    const { languageOptions, filters } = this.props;
    const languages = sortBy(languageOptions, 'value');
    return (
      <div key={FILTER_LANGUAGE}>
        {languageOptions.length > 0 && (
          <div className="sidebar-section">
            <FilterField
              label={i18n('language-label')}
              options={languages}
              onChange={change => this.handleLanguageChange(change)}
              defaultValue={filters[FILTER_LANGUAGE] ? filters[FILTER_LANGUAGE] : null}
              isDisabled={this.isFilterFieldDisabled(FILTER_LANGUAGE)}
            ></FilterField>
          </div>
        )}
      </div>
    );
  }

  renderRegistersLongnameFilter() {
    const { registersLongnameOptions, filters } = this.props;
    return (
      <div className="sidebar-section" key={FILTER_REGISTERS_LONGNAME}>
        <FilterField
          label={i18n('registers-label')}
          options={registersLongnameOptions}
          onChange={change => this.handleRegistersLongnameChange(change)}
          defaultValue={filters[FILTER_REGISTERS_LONGNAME] ? filters[FILTER_REGISTERS_LONGNAME] : null}
          isDisabled={this.isFilterFieldDisabled(FILTER_REGISTERS_LONGNAME)}
        ></FilterField>
      </div>
    );
  }

  renderZipAndCommunityFilter() {
    const { zipcodeAndCommunityOptions, filters } = this.props;
    return (
      <div className="sidebar-section" key={FILTER_ZIP_AND_COMMUNITY}>
        <FilterField
          label={i18n('zip-label')}
          options={zipcodeAndCommunityOptions}
          onChange={change => this.handleZipAndCommunityChange(change)}
          defaultValue={filters[FILTER_ZIP_AND_COMMUNITY] ? filters[FILTER_ZIP_AND_COMMUNITY] : null}
          isDisabled={this.isFilterFieldDisabled(FILTER_ZIP_AND_COMMUNITY)}
          customFilterLogic={true}
        ></FilterField>
      </div>
    );
  }

  renderLastnameFilter() {
    const { lastnameOptions, filters } = this.props;
    return (
      <div className="sidebar-section" key={FILTER_LASTNAME}>
        <FilterField
          label={i18n('lastname-label')}
          options={lastnameOptions}
          onChange={change => this.handleLastnameChange(change)}
          defaultValue={filters[FILTER_LASTNAME] ? filters[FILTER_LASTNAME] : null}
          isDisabled={this.isFilterFieldDisabled(FILTER_LASTNAME)}
          searchFromLeft={false}
        ></FilterField>
      </div>
    );
  }

  isFilterFieldDisabled(filterName) {
    switch (filterName) {
      case FILTER_REGISTERS_LONGNAME:
        return !!this.props.filters[FILTER_ZIP_AND_COMMUNITY] || !!this.props.filters[FILTER_REGION_NAME];
      case FILTER_ZIP_AND_COMMUNITY:
        return (
          !!this.props.filters[FILTER_LASTNAME] ||
          !!this.props.filters[FILTER_REGISTERS_LONGNAME] ||
          !!this.props.filters[FILTER_LANGUAGE] ||
          !!this.props.filters[FILTER_REGION_NAME]
        );
      case FILTER_LASTNAME:
        return (
          !!this.props.filters[FILTER_ZIP_AND_COMMUNITY] ||
          !!this.props.filters[FILTER_REGION_NAME] ||
          !!this.props.filters[FILTER_LANGUAGE]
        );
      default:
        return (
          !!this.props.filters[FILTER_ZIP_AND_COMMUNITY] ||
          !!this.props.filters[FILTER_LASTNAME] ||
          !!this.props.filters[FILTER_REGISTERS_LONGNAME]
        );
    }
  }
}

SidebarFilter.defaultProps = defaultProps;

export default SidebarFilter;
